//workout categories and respective names and image paths. 
export const categories = {
    1: {
        name: 'Weights',
        src: '/images/weights.jpg'
    },
    2: {
        name: 'Swimming',
        src: '/images/swimming.jpg'
    },
    3: {
        name: 'Running',
        src: '/images/running.jpg'
    },
    4: {
        name: 'HIIT',
        src: '/images/HIIT.jpg'
    }
}